import { getMiniHostAppDetail } from 'mini-host-bridge/lib/getMiniHostAppDetail';
import { ThemeMode } from '../schema/ThemeMode';

export const isThemeModeSetByHostApp = (): boolean =>
    Object.values(ThemeMode).includes(getMiniHostAppDetail()?.themeMode);
